import { AdministrationItemType, ICachedItem, IItemData } from "../data-structures";

export class ItemCache {
  private cachedItems: ICachedItem[] = [];
  private typesExcludedFromCache: AdministrationItemType[] = [];
  constructor(typesExcludedFromCache: AdministrationItemType[]) {
    if (typesExcludedFromCache) {
      this.typesExcludedFromCache = typesExcludedFromCache;
    }
  }

  public getCachedItem(id: number, type: AdministrationItemType): ICachedItem {
    return this.cachedItems.find((cachedItem) => cachedItem.id === id && cachedItem.type === type);
  }

  public addOrUpdateItem(itemData: IItemData): ICachedItem {
    const type = itemData?.type;
    const id = itemData?.dto?.id;
    if (!type || !id) {
      console.error("ItemCache.addOrUpdateItem: invalid itemData", itemData);
    }

    if (this.typesExcludedFromCache.includes(type)) {
      return null;
    }

    let cachedItem = this.getCachedItem(id, type);
    if (cachedItem) {
      Object.assign(cachedItem.itemData, itemData);
    } else {
      cachedItem = {id, type, itemData};
      this.cachedItems.push(cachedItem);
    }
    return cachedItem;
  }

  public removeItem(id: number, type: AdministrationItemType) {
    if (this.typesExcludedFromCache.includes(type)) {
      return null;
    }

    const cachedItems = this.cachedItems.filter((cachedItem) => !(cachedItem.id === id && cachedItem.type === type));
    this.cachedItems = cachedItems;
  }

  public resetCache() {
    this.cachedItems = [];
  }
}
